import { capsLine, type PanoCaps } from './pano-caps.js';

/**
 * What the 360° photo shown went up as, for the `?perf=1` HUD (ADR-041): a
 * cube's raw ASTC 6x6 blocks or the JPEG path's RGBA faces, its face, how
 * long the upload took at the black, and what it holds on the GPU. Pieter
 * reads it on the Quest to see that the cube path is the one taken.
 */
export type PanoShown = {
  readonly format: 'ASTC_6x6' | 'RGBA';
  /** A face's side, px. */
  readonly size: number;
  /** The upload at the black (`initTexture`), ms. */
  readonly ms: number;
  readonly bytes: number;
};

/** The photo shown last; one stage, so one at a time. */
let shown: PanoShown | undefined;

/** Called as a background goes up (pano.ts, rendererGpu). */
export function markPanoShown(next: PanoShown | undefined): void {
  shown = next;
}

/** e.g. `pano ASTC_6x6 · 2048² · 31 ms · 11 MB` (MB as the budget counts them: 10⁶ bytes). */
export function panoLine(photo: PanoShown): string {
  return (
    `pano ${photo.format} · ${photo.size}² · ${Math.round(photo.ms)} ms · ` +
    `${Math.round(photo.bytes / 1e6)} MB`
  );
}

/** The HUD's lines for a pano lesson: the GPU's caps, and the photo shown once one is. */
export function panoHudLines(caps: PanoCaps): string[] {
  return shown ? [capsLine(caps), panoLine(shown)] : [capsLine(caps)];
}
